var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfRemediationSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385.086,
    height: 415.289,
    viewBox: "0 0 385.086 415.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF_Remediation_Sad",
    "data-name": "PDF Remediation Sad",
    transform: "translate(-396 -2315.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17999",
    "data-name": "Group 17999",
    transform: "translate(60 -130)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 166.1,
    cy: 32.1,
    rx: 166.1,
    ry: 32.1,
    transform: "translate(340 2796.4)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17990",
    "data-name": "Group 17990",
    transform: "translate(-538.414 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_1_",
    "data-name": "search (1)",
    transform: "translate(877.414 2468.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12370",
    "data-name": "Path 12370",
    d: "M79.964,75.848a7.933,7.933,0,0,1-5.592-2.306L21.994,21.1A7.9,7.9,0,0,1,33.161,9.933L85.54,62.375a7.89,7.89,0,0,1-5.576,13.474Z",
    transform: "translate(291.235 113.687)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12369",
    "data-name": "Path 12369",
    d: "M90.982,157.881H90.95A78.971,78.971,0,0,1,90.982-.061h.047a78.971,78.971,0,0,1-.047,157.942ZM27.8,78.87a63.26,63.26,0,0,0,63.167,63.215h.016a63.183,63.183,0,0,0,.032-126.366h-.032A63.179,63.179,0,0,0,27.8,78.87Z",
    transform: "translate(177.593 0)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12371",
    "data-name": "Path 12371",
    d: "M276.425,379.1H39.489A39.534,39.534,0,0,1,0,339.608V39.489A39.544,39.544,0,0,1,39.489,0h150.57a7.9,7.9,0,0,1,0,15.8H39.489A23.723,23.723,0,0,0,15.8,39.489V339.608A23.723,23.723,0,0,0,39.489,363.3H276.425a23.723,23.723,0,0,0,23.694-23.694V174.834a7.9,7.9,0,0,1,15.8,0V339.608A39.534,39.534,0,0,1,276.425,379.1Z",
    transform: "translate(0 0.903)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12372",
    "data-name": "Path 12372",
    d: "M10.9,109.774a7.9,7.9,0,0,1-7.9-7.9V22.9A7.9,7.9,0,0,1,10.9,15H34.591a31.591,31.591,0,1,1,0,63.183H18.8v23.694A7.9,7.9,0,0,1,10.9,109.774Zm7.9-47.387h15.8a15.8,15.8,0,0,0,0-31.591H18.8Z",
    transform: "translate(44.387 222.839)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12373",
    "data-name": "Path 12373",
    d: "M47.489,109.774H15.9a7.9,7.9,0,0,1-7.9-7.9V22.9A7.9,7.9,0,0,1,15.9,15H47.489A23.723,23.723,0,0,1,71.183,38.694V86.081A23.723,23.723,0,0,1,47.489,109.774ZM23.8,93.979H47.489a7.911,7.911,0,0,0,7.9-7.9V38.694a7.911,7.911,0,0,0-7.9-7.9H23.8Z",
    transform: "translate(118.366 222.839)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12375",
    "data-name": "Path 12375",
    d: "M68.285,33.8H20.9a7.9,7.9,0,0,1,0-15.8H68.285a7.9,7.9,0,0,1,0,15.8Z",
    transform: "translate(192.344 267.226)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12374",
    "data-name": "Path 12374",
    d: "M20.9,109.774a7.9,7.9,0,0,1-7.9-7.9V38.694A23.723,23.723,0,0,1,36.694,15H68.285a7.9,7.9,0,0,1,0,15.8H36.694a7.911,7.911,0,0,0-7.9,7.9v63.183A7.9,7.9,0,0,1,20.9,109.774Z",
    transform: "translate(192.344 222.839)",
    fill: "#666",
    stroke: "#fff",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622",
    transform: "translate(593.065 2227.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M169.868,243.241a3.348,3.348,0,0,1-4.729-.262,37.261,37.261,0,0,0-55.3,0,3.349,3.349,0,1,1-4.99-4.468,43.958,43.958,0,0,1,65.276,0A3.352,3.352,0,0,1,169.868,243.241Z",
    transform: "translate(415.014 112.459)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6821",
    "data-name": "Path 6821",
    d: "M224.746,148.1A16.765,16.765,0,0,1,208,131.349a3.349,3.349,0,1,1,6.7,0,10.048,10.048,0,1,0,20.1,0,3.349,3.349,0,1,1,6.7,0A16.765,16.765,0,0,1,224.746,148.1Z",
    transform: "translate(354.553 168.268)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6822",
    "data-name": "Path 6822",
    d: "M106.793,131.349a3.349,3.349,0,1,1,6.7,0,16.746,16.746,0,1,1-33.492,0,3.349,3.349,0,1,1,6.7,0,10.048,10.048,0,1,0,20.1,0Z",
    transform: "translate(428.966 168.268)",
    fill: "#666",
    stroke: "#666",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12376",
    "data-name": "Path 12376",
    d: "M190.461,219.457a105.857,105.857,0,0,1-8.736-7.538c-2.783-2.783-5.262-5.479-7.417-8.048,3.361-10.385,4.834-15.739,4.834-18.593,0-12.125-4.381-14.612-10.959-14.612-5,0-10.959,2.6-10.959,14.962,0,5.451,2.986,12.069,8.9,19.76-1.448,4.42-3.15,9.518-5.062,15.265-.921,2.758-1.919,5.312-2.975,7.673-.86.382-1.695.771-2.5,1.174-2.9,1.452-5.661,2.758-8.219,3.971C135.706,238.992,128,242.645,128,249.858c0,5.237,5.69,8.48,10.959,8.48,6.792,0,17.048-9.072,24.54-24.355a145.337,145.337,0,0,1,25.075-6.764c6.114,4.7,12.868,9.2,16.139,9.2,9.058,0,10.959-5.237,10.959-9.628,0-8.637-9.868-8.637-14.612-8.637A86.536,86.536,0,0,0,190.461,219.457Zm-51.5,31.575a5.772,5.772,0,0,1-3.653-1.174c0-2.59,7.723-6.25,15.194-9.789.474-.225.956-.45,1.445-.682C146.458,247.344,141.032,251.032,138.959,251.032Zm25.571-65.4c0-7.656,2.376-7.656,3.653-7.656,2.583,0,3.653,0,3.653,7.306,0,1.541-1.027,5.394-2.908,11.409C166.06,192.27,164.53,188.485,164.53,185.628Zm2.8,39.263q.343-.952.664-1.926c1.355-4.067,2.576-7.72,3.664-11.009q2.274,2.5,4.9,5.13c.685.685,2.383,2.226,4.645,4.156C176.7,222.222,171.911,223.438,167.33,224.89Zm41.036,1.9c0,1.641,0,2.322-3.389,2.344-1-.214-3.3-1.57-6.136-3.5,1.031-.114,1.791-.171,2.219-.171C206.457,225.461,207.988,225.989,208.366,226.792Z",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 158.389, 2420.544)",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfRemediationSad);
export default __webpack_public_path__ + "static/media/pdf-remediation-sad.bd42bc3f1b29b8f2b3120b82c1b1990d.svg";
export { ForwardRef as ReactComponent };